module.exports = __webpack_public_path__ + "img/tooth8.7a64d003.png";